import {
  UPDATE_PROFILE_ACTIVITATE,
  UPDATE_PROFILE_ACTIVITATE_SUCCESS,
  UPDATE_PROFILE_ACTIVITATE_ERROR,
  UPDATE_PROFILE_DEACTIVATE,
  UPDATE_PROFILE_DEACTIVATE_SUCCESS,
  UPDATE_PROFILE_DEACTIVATE_ERROR,
} from "./actionTypes";

const initialState = {
  updateProfileActivateMsg: null,
  updateProfileDeActivateData: null,
  updateProfileActivateError: null,
  updateProfileDeActivateError: null,
  loading: false,
};

const userProfileAccount = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_ACTIVITATE:
      state = {
        ...state,
        updateProfileActivateMsg: null,
        loading: false,
      };
      break;
    case UPDATE_PROFILE_ACTIVITATE_SUCCESS:
      state = {
        ...state,
        updateProfileActivateMsg: action.payload,
        loading: true,
      };
      break;
    case UPDATE_PROFILE_ACTIVITATE_ERROR:
      state = {
        ...state,
        updateProfileActivateMsg: action.payload,
        loading: false,
      };
      break;
    // deactivate account in profile page
    case UPDATE_PROFILE_DEACTIVATE:
      state = {
        ...state,
        updateProfileDeActivateData: null,
        loading: false,
      };
      break;
    case UPDATE_PROFILE_DEACTIVATE_SUCCESS:
      state = {
        ...state,
        updateProfileDeActivateData: action.payload,
        loading: true,
      };
      break;
    case UPDATE_PROFILE_DEACTIVATE_ERROR:
      state = {
        ...state,
        updateProfileDeActivateData: action.payload,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default userProfileAccount;
